<template>
  <div class="child-page-div">
    <div class="page-content-div">
      <table-box ref="tableBox" :tableTitle="'敏感词汇'" :tableFieldNum="tableFieldNum" :action="action" :params="queryParams" :reloadData.sync="reloadData">
        <template #title-right>
          <div class="search-div">
            <label>
              <select v-model="searchType">
                <option value="1">词汇名称</option>
              </select>
            </label>
            <label>
              <input class="search-input" type="text" maxlength="20" v-model="searchMsg" placeholder="搜索相关数据..." />
            </label>
            <input class="search-btn" type="button" value="搜索" @click="onSearch" />
          </div>
        </template>
        <template #table-head>
          <th v-for="(item, index) in tableField" v-show="item.state" :key="index">{{ item.alias }}</th>
          <th v-if="isOperation" class="operation-th">操作</th>
        </template>
        <template v-if="$hasAuthority(9900000,9905000,[9905001])" #tableSubHead>
          <th class="table-sub-head-th" :colspan="tableFieldNum">
            <div class="div-btn cursor-el append-btn" @click="onAddWords">
              <img src="../../assets/add-data.png" height="14" width="14" alt="" />
              <label class="cursor-el">添加词汇</label>
            </div>
          </th>
        </template>
        <template #table-body="props">
          <tr>
            <template v-for="(item, index) in tableField">
              <td v-if="item.isHtml" :key="index" v-show="item.state" v-html="item.value(props.item, item.name)" />
              <td v-else :key="index" v-show="item.state">{{ item.value(props.item, item.name) }}</td>
            </template>
            <td v-if="isOperation">
              <div class="operation-btn-div">
                <span v-if="$validateAuthority(9900000,9905000,9905003)" class="cursor-el" @click="onEditItem(props.item)">编辑</span>
                <span v-if="$validateAuthority(9900000,9905000,9905002)" class="cursor-el" @click="onDelItem(props.item)">删除</span>
              </div>
            </td>
          </tr>
        </template>
      </table-box>
    </div>
  </div>
</template>

<script>
import TableBox from "../../components/TableBox";
import { getSensitiveWordsItems, postSensitiveWordsAdd, postSensitiveWordsEdit, postSensitiveWordsDel } from "../../common/api";

export default {
  name: "SensitiveWords",
  components: { TableBox },
  data() {
    return {
      action: getSensitiveWordsItems,
      reloadData: false,
      searchType: "1",
      searchMsg: "",
      queryParams: {
        type: 0,
        msg: "",
        pageSize: 20
      },
      tableField: [
        { state: true, alias: "编号", name: "id", title: "id", isHtml: false, value: this.getObjValue },
        { state: true, alias: "敏感词", name: "words", title: "words", isHtml: false, value: this.getObjValue },
        { state: true, alias: "更新人", name: "updater", title: "updater", isHtml: false, value: this.getObjValue },
        { state: true, alias: "更新时间", name: "updateTime", title: "updateTime", isHtml: false, value: this.getObjValue }
      ]
    };
  },
  computed: {
    isOperation() {
      return this.$hasAuthority(9900000,9905000,[9905001]);
    },
    tableFieldNum() {
      let num = 0;
      this.tableField.forEach(function(value) {
        if (value.state) {
          ++num;
        }
      });
      return num;
    }
  },
  methods: {
    getObjValue(item, field) {
      return item[field];
    },
    onReloadData() {
      this.reloadData = true;
    },
    onSearch() {
      this.queryParams.type = this.searchType;
      this.queryParams.msg = this.searchMsg.trim();
    },
    onAddWords() {
      let _this = this;
      this.$layer.prompt(
        {
          title: "添加词汇",
          maxlength: 20,
          area: ["300px", "200px"]
        },
        function(val, index) {
          if(Object.prototype.toString.call(val) !== "[object String]" || val.length < 1 || val.length > 20){
            _this.$layer.msg("请输入1~20位词汇信息");
            return;
          }

          postSensitiveWordsAdd({ words: val })
            .then(() => {
              _this.onReloadData();
              _this.$layer.close(index);
              _this.$layer.msg("操作成功");
            })
            .catch(error => {
              _this.$layer.close(index);
              if(Object.prototype.hasOwnProperty.call(error, "data") && Object.prototype.hasOwnProperty.call(error.data, "status")){
                _this.$layer.msg(error.data.msg);
              }else{
                _this.$layer.msg("操作失败");
              }
            });
        }
      );
    },
    onEditItem(item) {
      let _this = this;
      this.$layer.prompt(
        {
          title: "编辑词汇",
          value: item.words,
          area: ["300px", "200px"]
        },
        function(val, index) {
          if(Object.prototype.toString.call(val) !== "[object String]" || val.length < 1 || val.length > 20){
            _this.$layer.msg("请输入1~20位词汇信息");
            return;
          }

          postSensitiveWordsEdit({ id: item.id, words: val })
            .then(() => {
              _this.onReloadData();
              _this.$layer.close(index);
              _this.$layer.msg("操作成功");
            })
            .catch(error => {
              _this.$layer.close(index);
              if(Object.prototype.hasOwnProperty.call(error, "data") && Object.prototype.hasOwnProperty.call(error.data, "status")){
                _this.$layer.msg(error.data.msg);
              }else{
                _this.$layer.msg("操作失败");
              }
            });
        }
      );
    },
    onDelItem(item) {
      this.$layer.confirm(`是否删除词汇【${item.words}】？`, layerid => {
        postSensitiveWordsDel({ id: item.id })
          .then(() => {
            this.$layer.msg("操作成功");
            this.onReloadData();
            this.$layer.close(layerid);
          })
          .catch(error => {
            this.$layer.close(layerid);
            if (Object.prototype.hasOwnProperty.call(error, "data") && Object.prototype.hasOwnProperty.call(error.data, "status")) {
              this.$layer.msg(error.data.msg);
            } else {
              this.$layer.msg("操作失败");
            }
          });
      });
    }
  }
}
</script>

<style lang="less" scoped>
.child-page-div {
  width: 100%;
  .page-content-div {
    border-radius: 5px;
    background-color: #ffffff;
    padding: 30px 20px 10px 20px;
    .search-div {
      height: 100%;
      display: flex;
      select {
        width: 110px;
        height: 100%;
        border: 1px solid #dcdcdc;
      }
      .search-input {
        width: 140px;
        height: 33px;
        border: 1px solid #dcdcdc;
        padding: 0 15px;
        margin-left: 5px;
      }
      .search-btn {
        width: 80px;
        height: 100%;
        color: #f4f6f5;
        border: none;
        background: #4676c8;
      }
    }
    .table-sub-head-th {
      .div-btn {
        float: left;
        width: 88px;
        height: 23px;
        border: 1px solid #e5e5e5;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          margin-right: 10px;
        }
      }
      .append-btn {
        margin-left: 15px;
        margin-right: 10px;
      }
    }
    .operation-th {
      width: 80px;
    }
    .operation-btn-div {
      display: flex;
      justify-content: space-around;
    }
  }
}
</style>